module.exports = __webpack_public_path__ + "img/ic_criticalthinking@2x.f105edf3.png";